export default {
	er_cover_default_title: 'Revizuirea performanței',
	er_page_success_metrics: 'Ce s-a schimbat luna aceasta',
	er_page_success_metrics_range: 'Ce s-a schimbat în această perioadă',
	er_page_success_metrics_week: 'Ce s-a schimbat săptămâna aceasta',
	er_page_comparison: 'Rezumat comparativ',
	er_page_period_summary: 'Rezumatul lunii',
	er_page_period_summary_range: 'Rezumatul perioadei',
	er_page_period_summary_week: 'Rezumatul săptămânii',
	er_page_each_month: 'Fiecare lună',
	er_page_rooms: 'Camere',
	er_rooms_note: 'Fiecare cameră în {month}, cel mai bun scor primul.',
	er_page_shift_comparison: 'Comparație pe tură',
	er_page_shift_summary: 'Pe tură',
	er_page_response_time: 'Timp mediu de răspuns (min)',
	er_page_avg_score: 'Scor de experiență',
	er_page_complaints_vs_visits: 'Reclamații vs. Vizite',
	er_page_performance_trends: 'Tendințe de performanță',
	er_page_complaint_drivers: 'Cauzele reclamațiilor',

	er_board_working: 'S-a îmbunătățit față de {month}',
	er_board_attention: 'Necesită atenție față de {month}',
	er_board_empty: 'Nu există schimbări notabile luna aceasta.',
	er_board_empty_range: 'Nu există schimbări notabile în această perioadă.',
	er_board_empty_week: 'Nu există schimbări notabile săptămâna aceasta.',
	er_findings_intro: 'Comparat cu {month}. Sunt afișate doar schimbările notabile.',
	er_verdict_improved: 'Îmbunătățit',
	er_verdict_watch: 'Necesită atenție',

	er_col_metric: 'Indicator',
	er_col_avg: 'Medie YTD',
	er_col_lifetime_avg: 'Medie de la început',
	er_comparison_note: 'Media YTD este valoarea din ianuarie până în {month}.',
	er_lifetime_note: 'De la început este media lunară din prima zi cu date până în {month}.',
	er_comparison_note_week: 'Săptămâna raportului este comparată cu săptămâna anterioară selectată.',
	er_period_only_note: 'Cifrele sunt doar pentru {month}.',
	er_each_month_note: 'Fiecare lună din perioada selectată. O lună fără date rămâne goală.',
	er_col_inc_dec: 'Var.',
	er_col_complaint: 'Reclamație',
	er_col_qty: 'Cant.',
	er_total: 'Total',

	er_metric_avg_score: 'Scor de experiență',
	er_metric_avg_response_time: 'Timp mediu de răspuns',
	er_metric_cleaner_arrivals: 'Sosiri ale personalului de curățenie',
	er_metric_supervisor_inspections: 'Inspecții ale supervisorilor',
	er_metric_complaints_vs_visits_pct: 'Reclamații vs. vizite (%)',
	er_metric_complaints: 'Reclamații',
	er_metric_customer_visits: 'Vizite',
	er_metric_expired_slas: 'SLA-uri expirate',
	er_unit_min: 'min',
	er_stat_expected_sla: 'SLA așteptat',
	er_stat_vs_minutes: 'față de {value} în {month}',
	er_stat_vs_count: 'față de {value} în {month}',
	er_label_complaints: 'Reclamații',
	er_label_visits: 'Vizite',
	er_label_complaints_per_visits: 'Reclamații / vizite',
	er_chart_ratio: 'Raport reclamații/vizite',
	er_chart_ytd_window: 'Din ianuarie până în {month}.',
	er_cv_formula: 'Reclamații împărțite la vizitele la toaletă, în procente: ({complaints} ÷ {visits}) × 100 = {ratio}% în {month}.',
	er_export_kpis_title: 'Ce conține raportul',
	er_export_kpis_desc: 'Toate acestea sunt în raport. Opriți una ca să o lăsați afară.',
	er_export_select_all: 'Selectează tot',
	er_export_clear_all: 'Debifează tot',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Perioada raportului',
	er_export_grain: 'Raport după',
	er_export_grain_month: 'Lună',
	er_export_grain_week: 'Săptămână',
	er_export_week_starts: 'Săptămâna începe în',
	er_export_week_starts_sunday: 'duminică',
	er_export_week_starts_monday: 'luni',
	er_export_report_month: 'Luna raportului',
	er_export_from_month: 'Din luna',
	er_export_to_month: 'Până în luna',
	er_export_period_note_range: 'Raportul însumează fiecare lună de la început până la sfârșit. Când comparația este pornită, se folosește perioada anterioară de aceeași lungime. Cifrele de la începutul anului rămân din ianuarie până în luna finală.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'Perioada anterioară de aceeași lungime.',
	er_export_report_week: 'Săptămâna raportului',
	er_export_compare_month: 'Compară cu',
	er_export_shift: 'Tură',
	er_export_shift_all: 'Toate turele',
	er_export_no_shifts: 'Această locație nu are ture active.',
	er_export_render_failed: 'Raportul nu a putut fi generat corect, așa că nu a fost descărcat. Reîncărcați pagina și încercați din nou.',
	er_export_comparison: 'Comparație',
	er_export_include_previous: 'Include perioada anterioară',
	er_export_comparison_on: 'Pornit',
	er_export_comparison_off: 'Oprit',
	er_export_no_previous_data: 'Nu există date înainte de această perioadă, așa că nu există cu ce compara.',
	er_export_compare_previous: 'Luna precedentă',
	er_export_compare_previous_week: 'Săptămâna precedentă',
	er_export_compare_last_year: 'Aceeași lună anul trecut',
	er_export_no_periods: 'Acest sit are nevoie de cel puțin o lună de date pentru a exporta un raport.',
	er_export_no_periods_week: 'Acest sit are nevoie de cel puțin o săptămână de date pentru a exporta un raport.',
	er_export_period_note: 'Sunt listate doar lunile cu date. Valorile de la începutul anului acoperă întotdeauna ianuarie până în luna raportului.',
	er_export_period_note_week: 'Sunt listate doar săptămânile cu date. Comparația este întotdeauna cu o săptămână anterioară.',
	er_export_period_note_single_week: 'Sunt listate doar săptămânile cu date.',

	er_find_response_time_title: 'Timp mediu de răspuns',
	er_find_response_time_change:
		'S-a schimbat de la {previous} la {current} minute ({change}).',
	er_find_avg_score_title: 'Scor de experiență',
	er_find_score_eased: 'A scăzut de la {previous} la {current}.',
	er_find_score_improved: 'A crescut de la {previous} la {current}.',
	er_find_score_ytd_inline: 'Este egal cu media de la începutul anului ({ytd}).',
	er_find_score_ytd_inline_range: 'Egal cu media din ianuarie până în {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Media de la începutul anului: {ytd}.',
	er_find_score_ytd_against_range: 'Media din ianuarie până în {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Raport reclamații/vizite',
	er_find_complaints_ratio_improved: 'S-a îmbunătățit de la {previous} la {current}.',
	er_find_complaints_ratio_rose: 'S-a schimbat de la {previous} la {current}.',

	er_nar_cv_year_improved:
		'Reclamațiile față de vizitele la toaletă s-au îmbunătățit de la {from} la {to} pe parcursul anului.',
	er_nar_cv_year_rose: 'Reclamațiile față de vizitele la toaletă au crescut de la {from} la {to} pe parcursul anului.',
	er_nar_cv_moved: 'Reclamațiile față de vizitele la toaletă s-au modificat de la {previous} la {current}.',
	er_nar_cv_current: 'Reclamațiile față de vizitele la toaletă sunt de {current}.',
	er_nar_types_total: 'Total reclamații {total}.',
	er_nar_types_1: 'Principala reclamație: {a} ({ap}%).',
	er_nar_types_2: 'Principala reclamație: {a} ({ap}%), urmată de {b} ({bp}%).',
	er_nar_types_3: 'Principala reclamație: {a} ({ap}%), urmată de {b} ({bp}%) și {c} ({cp}%).',
	er_find_rooms_slowest: 'Camerele cu cel mai lung timp de răspuns luna aceasta: {rooms}.',
	er_find_rooms_slowest_range: 'Camerele cu cel mai lung timp de răspuns în această perioadă: {rooms}.',
	er_find_rooms_slowest_week: 'Camerele cu cel mai lung timp de răspuns săptămâna aceasta: {rooms}.',
	er_find_rooms_lowest_score: 'Camerele cu cel mai mic scor luna aceasta: {rooms}.',
	er_find_rooms_lowest_score_range: 'Camerele cu cel mai mic scor în această perioadă: {rooms}.',
	er_find_rooms_lowest_score_week: 'Camerele cu cel mai mic scor săptămâna aceasta: {rooms}.',

	er_find_so_what_ratio: 'Cea mai mare parte a schimbării a venit din {rooms}.',
	er_find_so_what_type: 'Reclamația principală: {name} ({percent}%).',
	er_hot_slowest: 'Camerele cu cel mai lung timp de răspuns',
	er_hot_expired_slas: 'Camere care au depășit SLA-ul',
	er_hot_ratio: 'Camerele cu cea mai mare schimbare a ratei de reclamații',
	er_hot_top_type: 'Camerele cu cele mai multe reclamații de tipul "{name}"',
	er_hot_col_room: 'Cameră',
	er_col_response: 'Răspuns',
	er_col_cleaners: 'Curățenie',
	er_col_score: 'Scor',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Raport',
	er_hot_col_change: 'Schimbare',
	er_hot_col_count: 'Cant.',
	er_hot_empty: 'Nu există evidențieri la nivel de cameră luna aceasta.',
	er_hot_empty_range: 'Nu există evidențieri la nivel de cameră în această perioadă.',
	er_hot_empty_week: 'Nu există evidențieri la nivel de cameră săptămâna aceasta.',
	er_cover_highlights: 'Luna aceasta',
	er_cover_highlights_range: 'Această perioadă',
	er_cover_highlights_week: 'Săptămâna aceasta',
	er_cover_score_rose: 'Scorul de experiență a crescut.',
	er_cover_score_eased: 'Scorul de experiență a scăzut.',
	er_cover_response_improved: 'Timpul de răspuns s-a îmbunătățit.',
	er_cover_response_slowed: 'Timpul de răspuns a crescut.',
	er_cover_ratio_fell: 'Raportul reclamații / vizite a scăzut.',
	er_cover_ratio_rose: 'Raportul reclamații / vizite a crescut.',
	er_export_pdf: 'PDF tablou',
	er_export_executive: 'Raport executiv',
	'executive-report': 'Raport executiv',
	er_export_csv: 'CSV',
	er_export_status_title: 'Se creează raportul',
	er_export_status_fetch: 'Se încarcă cifrele',
	er_export_status_layout: 'Se așază paginile',
	er_export_status_page: 'Pagina {page} din {total}',
	er_footer_copyright: 'Acest raport a fost generat prin sistemul BuzzzTech.',
	er_contact_line: 'Aveți întrebări sau doriți să explorați datele mai în detaliu? Contactați echipa de Customer Success BuzzzTech: {email} sau {phone}.',
};
